module.exports = __webpack_public_path__ + "img/your_kousoku.d2fff2d4.jpg";